export default {"src":"/_next/static/media/stiftelsen-sapling-badge-gold.590ab7b4.svg","height":353,"width":353,"blurWidth":0,"blurHeight":0};